<template>

  <div ref="scrollableElement">

    <div class="card-content">

        <div class="content">
        
            <table class="table is-bordered">
        
                <tr>
        
                    <th width="10" v-if="$parent.canManageUser && !isSuperAdmin"><b-checkbox v-model="checkedAllUsers"></b-checkbox></th>
        
                    <th><span v-if="$parent.canManageUser && !isSuperAdmin">Check/Uncheck All</span><span v-else>Fullname</span></th>
        
                    <th >Actions</th>
        
                </tr>

                <tr v-for="user in filteredUsers" :key="user.id">
                
                    <td width="10" v-if="$parent.canManageUser && !isSuperAdmin">

                        <b-checkbox :native-value="user.id" v-model="checkedUsers" ></b-checkbox>
                   
                    </td>
                   
                    <td>

                      <strike v-if="user.archivedAt != null">{{ user.fullName }}</strike>

                      <span v-else>{{ user.fullName }}</span>
  
                      <!-- <div class="role-div">
            
                        <span class="tag is-dark" v-for="(role, key) in user.roles" @click="$emit('update:keyword', role.name)">{{ role.name }}</span>

                      </div> -->

                        <b-button class='admin-star-role' v-if="hasAdminRole(user.roles)"><i class="fa fa-star"></i></b-button>

                    </td>
                   
                    <td class="is-narrow">

                        <!-- <i class="fa fa-star"></i> -->


                        <!-- <b-button
                          :type="{ 'is-dark': selected && selected.id === userrow.id }"
                          size="is-small"
                          @click="$emit('update:selected', user)" v-if="!isSuperAdmin">EDIT</b-button> -->

                        <b-button
                          size="is-small"
                          :loading="teleporting == user.id"
                          :disabled="user.id == $store.state.Auth.user.id || user.archivedAt"
                          @click="teleport(user.id)"
                          v-if="canTeleportAs(user)" >TELEPORT</b-button>

                    </td>
                </tr>
            </table>

        </div>
    </div>

  </div>

</template>

<script>

import BaseTable from "@/components/partials/BaseTable";

import Roles from "@/helpers/roles";

import Permissions from "@/helpers/permissions";

import { AuthService } from "@/services/auth.service";

import { UserService } from "@/services/user.service";

import { startRouteMixin } from "@/mixins/startRouteMixin";

import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

export default {
  columns: [
    { field: "name", label: "", meta: { rowSlot: "rowFullName" } },
    {
      field: "actions",
      label: "",
      width: "150",
      meta: { rowSlot: "rowActions", class: "has-text-centered" }
    }
  ],
  perPage: 1000,
  props: {
    organizationId: {
      type: Number | String,
      required: true
    },

    keyword: {
      type: Number | String,
    },

    create: {
      type: Boolean,
    },
    
    archivedAt: {
      required: true
    },

    selected: {
      type: Object,
      default: () => {}
    },
    height: {
      type: Number,
      default: 500
    },
    enableApply: {
      type: Boolean
    }
  },
  components: {
    BaseTable
  },
  mixins: [startRouteMixin],

  data: () => ({

    authService: AuthService,
    
    userService: UserService,
    
    scrollableElement: null,
    
    loading: false,
    
    teleporting: null,
    
    users: [],

    checkedAllUsers: false,

    checkedUsers: [],

  }),
  computed: {
    scrollableHeight() {
      return this.height - 44 - 56; // header height, footer height
    },
    isSuperAdmin() {
      return this.$store.getters["Auth/hasRole"](Roles.SUPERADMIN);
    },

    usersId() {

        return this.users.map(user => user.id)

    },


    filteredUsers() {

        let keyword = this.keyword;

        return this.users.filter(user => {

            let roleExist = false;

            user.roles.forEach(role => {

                if (roleExist == false) {

                    roleExist = role.name.toLowerCase().includes(keyword.toLowerCase());
                
                }

            });
            
            let nameExist = user.fullName.toLowerCase().includes(keyword.toLowerCase());

            return nameExist || roleExist;

        });

    }

  },

  watch: {

    archivedAt(){
    
      this.$nextTick(() => {
    
        this.fetch();
    
      })

    },

    checkedAllUsers(value) {

        this.checkedUsers = value ? this.usersId : [];

    },

    checkedUsers(value) {

      this.$emit("update:enableApply", value.length ? true : false);

    },

    users(value) {

      this.$emit('update:create', value.length ? false : true);

    }

  },
  methods: {

    fetch() {

        this.userService.all({ order_by:'asc', sort_by: 'desc', per_page:1000, page:1, firmId: this.organizationId, 

            filter_by:'first_name', order_by:'asc', includes: 'permissions,roles,tags', archived: this.archivedAt })

            .then(response => {

                this.users = JsonDenormalizer.denormalize(response);

        });

      // return this.$refs.baseTable.fetchData();

    },

    updateRole(role) {

        this.userService.updateRole({role:role, users: this.checkedUsers}).then(response => {

            this.$buefy.toast.open({

                message: "Personel Role Updated",
                
                type: "is-info",
                
                position: "is-top-right"
            
            });

        });

    },

    sortRole(roles) {

        const sortRole = roles;

        return sortRole.sort((a, b) => {

            var x = a.name.toLowerCase(), y = b.name.toLowerCase();

            return x < y ? -1 : x > y ? 1 : 0;

        });

    },

    async teleport(id) {
      this.teleporting = id;

      try {
        const token = await this.authService
          .teleport({
            id
          })
          .then(response => response.data.token);

        this.$store.dispatch("Auth/setToken", token);
        this.navigateToStartRoute();
      } catch (err) {}

      // this.teleporting = null;
    },
    onSelect(selected) {
      this.$emit("update:selected", selected);
    },
    canTeleportAs(user) {

      // return (this.isSuperAdmin
      //   || (this.$store.state.Auth.user.firmId == user.firmId
      //     && this.$store.getters["Auth/hasPermission"](Permissions.CAN_TELEPORT_AS_COLLEAGUE)));

      return this.isSuperAdmin || this.$store.getters["Auth/hasPermission"](Permissions.CAN_TELEPORT_AS_COLLEAGUE);
    },

    searchTeleport() {

      if (this.keyword != '' && this.filteredUsers.length == 1) {
        
        this.teleport(this.filteredUsers[0].id);

      }

    },

    hasAdminRole(roles) {

        return roles.find(element => element.name.toLowerCase() == 'admin');

    }


  },

  mounted() {
    this.scrollableElement = this.$refs.scrollableElement;
    this.fetch();
  }


};
</script>

<style scoped>
.card-content {
  padding: 0;
}

.role-div{

    float: right;

}

.role-div .tag{
    cursor: pointer;
}

.role-div .tag{

    margin-left: 3px;

}

.admin-star-role{
    float: right;
/*    color: #0099ff;
    padding: 1px 25px;
    margin-top: 6px;
    font-size: 15px;*/
}


</style>



// WEBPACK FOOTER //
// src/components/pages/Users/list-new/partials/userTable.vue